@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.breadcrumb {
  margin-bottom: spacers.getSpacer(xs);

  @media screen and (min-width: map.get($grid-breakpoints, md)) {
    margin-bottom: spacers.getSpacer(s);
  }
}
